module.exports = __webpack_public_path__ + "images/application/i-ac-sign-nav-e922939a.svg";